import React from 'react';

import { Hidden } from '@material-ui/core';
import styled from 'styled-components';

import Breadcrumbs from '@navigation/Breadcrumbs';
import FormCommerce from '@components/Forms/FormCommerce';

const ContainerForm = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const EditCommerce = ({ route }) => (
  <>
    <Hidden smDown>
      <Breadcrumbs route={route} />
    </Hidden>
    <ContainerForm>
      <FormCommerce edit />
    </ContainerForm>
  </>
);

export default EditCommerce;
